import {
  listCalendarItems,
  updateCalendarItem,
} from '@akin-home/calendar/combined';
import { addDays, isSameMinute, startOfDay } from 'date-fns';
import { QueryClient } from 'react-query';
import { apiQueryKeys } from '../../../calendar/combined/getCalendarItemAPIFunctions';
import { CalendarItemType } from '../../../models';
import { parseCommandDateAndTime } from '../functions';

/**
 * Handles an update_calendar_item command
 * Currently only updates the start date and time
 */
const updateCalendarItemCommand = async (
  /** The command data */
  data: any,
  habitatID: string,
  /** Query client for invalidating the cache upon item create */
  queryClient: QueryClient
): Promise<string> => {
  const { type = 'Event', not_found_item } = data;
  const { start, to } = parseDates(data);

  const date = new Date(data.date);

  const query = {
    habitatID,
    filter: {
      from: startOfDay(date).toISOString(),
      to: startOfDay(addDays(date, 1)).toISOString(),
    },
  };

  /** Initial server side fetch */
  const items = await listCalendarItems({
    types: [type],
    query,
  });

  /** Get the exact match */
  const item = items.find((item) => isSameMinute(item.start, start));

  /** No match was found! */
  if (!item) return not_found_item;

  if (!item.isRecurrence) {
    await updateCalendarItem({
      ...item,
      start: to,
    });

    queryClient.invalidateQueries(apiQueryKeys[type as CalendarItemType]);
  }
  return '';
};

/** Parses the start date from the command data */
const parseDates = ({ start_date, start_time, to_date, to_time }: any) => {
  const start = parseCommandDateAndTime({ date: start_date, time: start_time });

  const to = parseCommandDateAndTime({
    date: to_date || start_date,
    time: to_time,
  });

  return { start, to };
};

export default updateCalendarItemCommand;
